module.exports = __webpack_public_path__ + "img/MP.1318ad2e.png";